module.exports = __webpack_public_path__ + "img/outdoorArmingCameraAlinoDetect.5990271e.webp";